import { Translations } from "shared/types/languages";

export type Game = {
  id: number;
  externalId: string;
  productSupplierId: number | null;
  productId: number | null;
  categoryId: string | null;
  productName: string | null;
  name: string | null;
  displayName: string | null;
  demoPlayRestricted: boolean;
  realPlayRestricted: boolean;
  maintenanceModeEnabled: boolean;
  progressiveJackpots: string[];
  translations: Translations;
  isActive: boolean;
  bgImage: string | null;
  logoImage: string | null;
  tags: string[];
  tagTypes: string[];
  themeTags?: string[];
  themeTagTypes?: string[];
  metadata?: GameMetadata | null;
};

export type GameWithTagsCount = Game & {
  tagsCount: number;
};

export type GameOption = Game & {
  disabled?: boolean;
  addedByTag?: boolean;
  addedManually?: boolean;
};

export type GameTag = {
  id: string;
  name: string;
};

export type GameToUpdate = Omit<Game, "bgImage" | "logoImage"> & {
  bgImage: File;
  logoImage: File;
};

export type Product = {
  id: number;
  name: string;
  supplierId: number;
};

export type UpdateStatusParams = {
  gameId: string;
  status: boolean;
};

export type GameMetadata = {
  gameDescription: string;
  gameOptimisedDescription: string;
  gameDescriptionFromProvider: string;
  gameShortDescription: string;
  features: string[];
  gameInformation: GameMetadataGameInformationItem[];
  lowConfidenceInformation?: {
    [key: string]: string;
  };
};

export type GameMetadataGameInformationItem = {
  type?: string;
  value?: number | string | string[] | null;
};

export type GameRow = {
  id: string;
  name: string;
  displayName: string;
  productName: string;
  tagsCount: number;
  updatedAt: Date | string;
  status: boolean;
};

export enum GameInformationTypeEnum {
  VOLATILITY = "Volatility",
  RTP_EXACT = "RTP Exact",
  PAYLINES = "Paylines",
  GAME_FEATURES = "Game Features",
  JACKPOT_TYPE = "Jackpot Type",
  REELS = "Reels",
  ROWS = "Rows",
  LANGUAGE_SUPPORT = "Language Support",
  RELEASE_DATE = "Release Date",
  AUTOPLAY = "Autoplay",
  MIN_STAKE = "Min Stake",
  MAX_STAKE = "Max Stake",
  MAX_WIN = "Max Win",
}

export const GameMetadataTagsInformation = [
  GameInformationTypeEnum.VOLATILITY,
  GameInformationTypeEnum.JACKPOT_TYPE,
  GameInformationTypeEnum.LANGUAGE_SUPPORT,
  GameInformationTypeEnum.AUTOPLAY,
];
